/*** IMPORTS FROM imports-loader ***/
var define = false;

import facebookIcon from '@SvgIcon/social-facebook.svg';
import googleIcon from '@SvgIcon/social-google.svg';
import printerIcon from '@SvgIcon/printer.svg';
import twitterIcon from '@SvgIcon/social-twitter.svg';

import $ from 'jquery';
import svgIconHtml from '../../../shared/svgIconHtml';

export default {
  template: `
    <div class="social-share">
      <a 
          class="social-share-button facebook" 
          :href="facebookUrl" 
          @click="openShareWindow">
        ${svgIconHtml(facebookIcon)}
        <span class="social-share-button__caption">Like</span>
      </a>
      <a 
          class="social-share-button twitter" 
          :href="twitterUrl"
          @click="openShareWindow">
        ${svgIconHtml(twitterIcon)}
        <span class="social-share-button__caption">Tweet</span>
      </a>
      <a 
          class="social-share-button google" 
          :href="googleUrl"
          @click="openShareWindow">
        ${svgIconHtml(googleIcon)}
        <span class="social-share-button__caption">+1</span>
      </a>
      <a
          v-if="print" 
          class="social-share-button print"
          href="javascript:window.print()">
        ${svgIconHtml(printerIcon)}
        <span class="social-share-button__caption">Print</span>
      </a>
    </div>
  `,
  props: {
    url: {
      type: String,
      default: window.location.href,
    },
    text: {
      type: String,
      default() {
        return $.trim($('meta[name=description]').attr('content') || $(document).prop('title'));
      },
    },
    print: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    encodedUrl() {
      return encodeURIComponent(this.url);
    },

    encodedText() {
      return encodeURIComponent(this.text);
    },

    facebookUrl() {
      return `https://facebook.com/sharer/sharer.php?u=${this.encodedUrl}`;
    },

    twitterUrl() {
      let url = `https://twitter.com/share?url=${this.encodedUrl}`;
      if (this.text) {
        url += `&text=${this.encodedText}`;
      }
      return url;
    },

    googleUrl() {
      return `https://plus.google.com/share?url=${this.encodedUrl}`;
    },
  },
  methods: {
    openShareWindow(ev) {
      ev.preventDefault();
      window.open(ev.currentTarget.getAttribute('href'), null, 'width=600, height=400, location=0, ' +
        'menubar=0, resizeable=0, scrollbars=0, status=0, titlebar=0, toolbar=0');
    },
  },
};

